import { Modal, ModalBody, Button } from "reactstrap";
import { useTranslation } from "react-i18next";
import { IoClose } from "react-icons/io5";
import { SHOP_ENABLED } from "../../config/appMode";

const SubscribeToMembershipModal = ({
  membershipModalIsOpen,
  toggleSubscribeToMembershipModal,
  membershipForModal,
  userMembershipTier,
  userMembershipExpiryDate,
}) => {
  const { t } = useTranslation("common");

  const closeModal = () => {
    toggleSubscribeToMembershipModal();
  };

  // Membership details mapping
  const membershipDetails = {
    platinum: {
      nameKey: "vipPlatinumMembership",
      priceKey: "priceMonthly19_99",
      benefits: [
        "platinum_benefit_2000_tickets",
        "twoXTicketMultiplierShort",
        "discountedEntryFeesDetailPlatinum",
        "3000StarCoins",
        "redeemableCashback5_500",
        "diamondIconOverlayOnAvatar",
      ],
      color: "#3bb4e5",
    },
    gold: {
      nameKey: "vipGoldMembership",
      priceKey: "priceMonthly9_99",
      benefits: [
        "gold_benefit_750_tickets",
        "twoXTicketMultiplier",
        "discountedEntryFeesDetailGold",
        "1200StarCoins",
        "redeemableCashback5_150",
        "goldAvatarRing",
      ],
      color: "#e5c13b",
    },
    silver: {
      nameKey: "vipSilverMembership",
      priceKey: "priceMonthly5_99",
      benefits: [
        "silver_benefit_500_tickets",
        "discountedEntryFeeCasual250",
        "500StarCoins",
        "redeemableCashback5_50",
        "silverAvatarRing",
      ],
      color: "#bfc1c2",
    },
  };

  // Determine which membership to show (be defensive: membershipForModal can be an event/object when
  // the modal's toggle is invoked by reactstrap, so only call toLowerCase on strings).
  const selected =
    typeof membershipForModal === "string"
      ? membershipForModal.toLowerCase()
      : undefined;
  const details = membershipDetails[selected] || membershipDetails.silver;

  const userHasActiveMembership =
    userMembershipExpiryDate &&
    new Date(userMembershipExpiryDate.seconds * 1000) > new Date();
  const differentActiveTier =
    userHasActiveMembership &&
    userMembershipTier &&
    userMembershipTier !== selected;

  return (
    <Modal
      id="rewardHistoryModal"
      isOpen={membershipModalIsOpen}
      toggle={toggleSubscribeToMembershipModal}
      size={"lg"}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <ModalBody
        style={{
          padding: "2.5rem 2rem",
          borderRadius: 24,
          boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
          background: "#fff",
          minWidth: 340,
        }}
      >
        <div className="modalHeader" style={{ marginBottom: "1.5rem" }}>
          <div></div>
          <IoClose
            onClick={closeModal}
            style={{ color: "#888", fontSize: 28, fontWeight: 700 }}
          />
        </div>
        <div
          style={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <h2
            style={{
              color: details.color,
              fontWeight: 700,
              fontFamily: "Oswald, Poppins, sans-serif",
              fontSize: "2rem",
              marginBottom: "0.5rem",
              letterSpacing: "0.5px",
              textTransform: "uppercase",
            }}
          >
            {t(details.nameKey).toUpperCase()}
          </h2>
          <div
            style={{
              fontSize: "1.25rem",
              color: "#222a4d",
              fontWeight: 700,
              marginBottom: "2rem",
              fontFamily: "Poppins, Oswald, sans-serif",
            }}
          >
            {t(details.priceKey)}
          </div>
          <ul
            style={{
              textAlign: "left",
              display: "inline-block",
              background: "#f7f8fa",
              borderRadius: 16,
              padding: "1.5rem 2rem",
              marginBottom: "2.5rem",
              boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
              fontSize: "1.08rem",
              fontFamily: "Poppins, Oswald, sans-serif",
              color: "#222a4d",
              minWidth: 260,
              maxWidth: 400,
            }}
          >
            {details.benefits.map((benefit, idx) => (
              <li
                key={idx}
                style={{ marginBottom: "0.75rem", lineHeight: 1.6 }}
              >
                {t(benefit)}
              </li>
            ))}
          </ul>
        </div>
        {/* Only show checkout button when user is allowed to subscribe/extend this tier. */}
        {!differentActiveTier && SHOP_ENABLED ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "1.5rem",
            }}
          >
            <Button
              className="primaryBtn"
              style={{
                padding: "0.85rem 2.5rem",
                width: "fit-content",
              }}
              onClick={() => {
                // Redirect to checkout page with membership info
                window.location.href = `/shop/checkout?membership=${selected}`;
              }}
            >
              {t("checkout").toUpperCase()}
            </Button>
          </div>
        ) : null}
      </ModalBody>
    </Modal>
  );
};

export default SubscribeToMembershipModal;
